import { CheckCircle2, XCircle, Info } from "lucide-react";
import { useToastStore, type ToastTone } from "@/stores/toast.store";
import { cn } from "@/lib/cn";

const TONE_STYLES: Record<ToastTone, string> = {
  success: "border-l-4 border-l-success text-success",
  error: "border-l-4 border-l-danger text-danger",
  info: "border-l-4 border-l-primary text-primary",
};

const ICONS: Record<ToastTone, typeof Info> = {
  success: CheckCircle2,
  error: XCircle,
  info: Info,
};

export function Toaster() {
  const toasts = useToastStore((s) => s.toasts);
  const dismiss = useToastStore((s) => s.dismiss);

  return (
    <div className="fixed bottom-5 right-5 z-[3000] flex flex-col gap-2">
      {toasts.map((t) => {
        const Icon = ICONS[t.tone];
        return (
          <button
            key={t.id}
            onClick={() => dismiss(t.id)}
            className={cn(
              "flex items-center gap-2.5 bg-card border border-border rounded px-5 py-4 text-[13px] text-text shadow-card animate-slideIn text-left",
              TONE_STYLES[t.tone],
            )}
          >
            <Icon className="h-4 w-4 shrink-0" />
            <span className="text-text">{t.message}</span>
          </button>
        );
      })}
    </div>
  );
}
